import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { Button } from 'antd'
import { Icon, Flex, Header, QuickTip } from 'govwell-ui'

import { useUpdateUserIsAIStaffMemberMutation } from 'src/fetch/users'
import useDisclosure from 'src/hooks/use-disclosure'
import {
  useAmIAIStaffMember,
  useMyOrgId,
  useMyUser,
  useRefetchAppState,
} from 'src/layouts/AppStateContextLayout/utils'
import AddAIAdminModal from 'src/pages/AIAssistantSettingsPage/AddAIAdminModal'
import AIAdminTable from 'src/pages/AIAssistantSettingsPage/AIAdminTable'
import { QueryKey } from 'src/utils/queryClient'

const Team = () => {
  const queryClient = useQueryClient()
  const { mutateAsync: updateUserIsAIStaffMember } = useUpdateUserIsAIStaffMemberMutation()
  const userId = useMyUser()?.id
  const organizationId = useMyOrgId()
  const isAIStaffMember = useAmIAIStaffMember()
  const refetchAppState = useRefetchAppState()
  const handleAddMyselfToAIAdmin = useCallback(async () => {
    if (!userId) {
      return
    }
    await updateUserIsAIStaffMember({ id: userId, isAIStaffMember: true, organizationId })
    await refetchAppState?.()
    await queryClient.invalidateQueries({ queryKey: [QueryKey.AIStaffMembers] })
  }, [userId, organizationId, updateUserIsAIStaffMember, refetchAppState, queryClient])

  const addAIAdminModalState = useDisclosure()

  return (
    <>
      <Flex direction="column" gap={2}>
        <Flex justify="space-between" width="100%">
          <Flex align="center" gap={1}>
            <Header title="AI Admins" />
            <QuickTip content="AI Admins are granted access to the Community Assistant's Train, Routing, and Settings pages. Organization admins already have full access to these pages." />
          </Flex>
          <Flex gap={1} justify="end">
            {!isAIStaffMember && (
              <Button icon={<Icon.FaComment />} onClick={handleAddMyselfToAIAdmin}>
                Join AI Admin
              </Button>
            )}
            <Button icon={<Icon.FaPlus />} type="primary" onClick={addAIAdminModalState.open}>
              Add AI Admin
            </Button>
          </Flex>
        </Flex>
        <AIAdminTable />
      </Flex>
      {addAIAdminModalState.isOpen && <AddAIAdminModal onClose={addAIAdminModalState.close} />}
    </>
  )
}

export default React.memo(Team)
